import { LetsParkyClient } from "@letsparky/api-v2-client";
import { User, Device, Parking, Payment, Tenant, UserRole, TenantCreateParams, TenantUpdateParams } from "@letsparky/api-v2-client";

const config: Record<string, any> = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || "https://api-v2.letsparky.com/api/v2",
  environment: import.meta.env.VITE_API_ENVIRONMENT || "production",
  logLevel: import.meta.env.VITE_API_LOG_LEVEL || "info",
};

const apiClient = new LetsParkyClient(config);

export { User, Device, Parking, Payment, Tenant, UserRole, TenantCreateParams, TenantUpdateParams };
export default apiClient; 